export default {
  'parallel.form.flow': 'Rama',
  'parallel.form.addFlow': 'Agregar rama',
  'parallel.form.noFlows': 'Aún no hay ramas. Agregue al menos una.',
  'parallel.form.enabled': 'Habilitado',
  'parallel.form.disabled': 'Deshabilitado',
  'parallel.form.name': 'Nombre',
  'parallel.form.description': 'Descripción',
  'parallel.form.rejectionBehavior': 'Comportamiento de rechazo',
  'parallel.form.select.rejectParallelFlow': 'Rechazar solo esta rama',
  'parallel.form.select.rejectParallel': 'Rechazar la acción paralela',
  'parallel.form.select.rejectProcessInstance': 'Rechazar la solicitud',
};
